import { Grid, MenuItem, menuItemClasses, SelectChangeEvent } from '@mui/material';
import { useFormikContext } from 'formik';
import { memo, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';

import DownIcon from '../../../../../../../assets/icons/Icon_ArrowDown.svg?react';
import { ResourceType, useQueryGetGetResourcesByType } from '../../../../../../../backend';
import { errorToastConfig } from '../../../../../../../utils/utils';
import { ResourcesPageFormValues } from '../../../../../../pages/ResourcesPage';
import { StyledMuiTextField, StyledSelect } from '../ResourceFieldsLineProperties.style';
import { isBoardingGateProperties } from './ResourceFieldsLine.utils';
import { useReplaceNumberAt, useReplaceSelectAt } from './useReplaceValueAt';

export const ResourceFieldsLineBoardingGateProperties = memo(function ResourceFieldsLineBoardingGateProperties({
    index,
    arrayReplace,
}: {
    index: number;
    arrayReplace: (index: number, value: any) => void;
}) {
    const { values, initialValues, errors } = useFormikContext<ResourcesPageFormValues>();

    const { data: departureHalls } = useQueryGetGetResourcesByType(
        {
            type: ResourceType.DEP_HALL,
            includeNonActive: true,
        },
        {
            onError: () => {
                toast(<FormattedMessage id={'resourcesForm.error.default'} />, errorToastConfig);
            },
        },
    );
    const handleNumberChange = useReplaceNumberAt(index, arrayReplace);

    const handleSelectChange = useReplaceSelectAt(index, arrayReplace);

    const content = useMemo(() => values.resources[index].content, [index, values.resources]);
    const initialContent = useMemo(
        () => (values.resources[index].id ? initialValues.resources[index].content : null),
        [index, initialValues.resources, values.resources],
    );

    return isBoardingGateProperties(content) ? (
        <>
            <Grid item xs display={'flex'} justifyContent={'center'} alignItems={'center'}>
                <StyledMuiTextField
                    variant="filled"
                    type={'number'}
                    value={content.paxCapacity}
                    onChange={e => handleNumberChange('paxCapacity', e)}
                    InputProps={{
                        inputProps: { min: 1 },
                    }}
                    modified={
                        values.resources[index].id && isBoardingGateProperties(initialContent)
                            ? content.paxCapacity !== initialContent.paxCapacity
                            : undefined
                    }
                    error={!!errors[`resources[${index}]['paxCapacity']`]}
                    helperText={errors[`resources[${index}]['paxCapacity']`]}
                />
            </Grid>
            <Grid item xs display={'flex'} justifyContent={'center'} alignItems={'center'}>
                <StyledSelect
                    value={!departureHalls || departureHalls.length === 0 ? '' : content.departureHall}
                    onChange={(e: SelectChangeEvent<string>) => handleSelectChange('departureHall', e)}
                    IconComponent={DownIcon}
                    modified={
                        values.resources[index].id && isBoardingGateProperties(initialContent)
                            ? content.departureHall !== initialContent.departureHall
                            : undefined
                    }
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                [`& .${menuItemClasses.root}`]: {
                                    color: theme => theme.palette.primary.contrastText,
                                },
                            },
                        },
                    }}
                >
                    <MenuItem key={'empty'} value={''}>
                        {'-'}
                    </MenuItem>
                    {departureHalls
                        ?.map(r => r.name)
                        .map(name => (
                            <MenuItem key={name} value={name}>
                                {name}
                            </MenuItem>
                        ))}
                </StyledSelect>
            </Grid>
        </>
    ) : null;
});
